import { Head } from "@inertiajs/react"

import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { CentralMenu, type CentralItem } from "@/features/staff/organization/central-menu"
import { t } from "@/lib/i18n"

/**
 * The group's menu.
 *
 * The server refuses this route for a restaurant with no organization and for
 * one the platform has not granted `multi_location`, so there is no "you cannot
 * see this" state to render — only the menu itself.
 */

type Props = {
  organization: { id: number; name: string }
  items: CentralItem[]
  branchCount: number
  currency: string
  stations: { value: string; label: string }[]
}

export default function StaffLocationManageCentralItemsIndex({
  organization,
  items,
  branchCount,
}: Props) {
  const title = t("ui.react.pages.staff.location.manage.central_items.index.page_title")

  return (
    <>
      <Head title={`${title} · ${organization.name}`} />

      <MainContainer>
        <PageHeader title={title} description={organization.name} />
        <CentralMenu items={items} branchCount={branchCount} />
      </MainContainer>
    </>
  )
}

StaffLocationManageCentralItemsIndex.layout = (page: React.ReactNode) => (
  <StaffLayout>{page}</StaffLayout>
)
